import parse from 'html-react-parser';

import ApiState from '@/components/ApiState/ApiState';
import Layout from '@/components/Layout/Layout';
import Link from '@/components/LangLink/LangLink';
import NavLabel from '@/components/NavLabel/NavLabel';
import Overlay from '@/components/Overlay/Overlay';
import { EXPO_CONFIG } from '@/api/expoConfig';
import { useBodyClass } from '@/hooks/useBodyClass';
import { useBasicPage } from '@/api/useThesaurusTerm';
import { useNavigationStore } from '@/store/useNavigationStore';
import { splitTerm } from '@/utils/splitTerm';

import fotoCarmen from '@/assets/img/overlays/foto-carmen.png';
import segellsBlanc from '@/assets/img/overlays/segells-blanc.png';
import signatura from '@/assets/img/overlays/signatura.png';

function Home() {
    useBodyClass('home has-background-black');

    const pages = useNavigationStore((s) => s.pages);
    const menuPages = pages.filter((page) => page.menu === 'yes');
    const isReady = useNavigationStore((s) => s.isReady);

    const { data, isLoading, error } = useBasicPage(EXPO_CONFIG.rootId);
    const pageContent = data?.[0];
    const { title, abstract, body } = pageContent ?? {};
    const { primary: titlePrimary, secondary: titleSecondary } = splitTerm(title, '|');

    return (
        <Layout page="home">
            <div className="home--hero">
                <div className="is-flex is-flex-direction-column gap-5 has-text-white py-9">
                    <ApiState isLoading={isLoading} error={error}>
                        <>
                            {titlePrimary && (
                                <h1 className="fluid-34-68 is-uppercase has-text-primary is-family-secondary">
                                    {titlePrimary}
                                </h1>
                            )}
                            {titleSecondary && (
                                <h2 className="is-size-1 has-text-weight-normal is-uppercase">
                                    {titleSecondary}
                                </h2>
                            )}
                            {abstract && <p className="has-text-weight-light">{abstract}</p>}
                        </>
                    </ApiState>
                </div>
            </div>
            <div className="wrapper overlay-wrapper">
                <div className="overlay-space">
                    <Overlay
                        src={signatura}
                        style={{ top: 400, right: 280, zIndex: 8, maxWidth: 235 }}
                    />
                    <Overlay
                        src={segellsBlanc}
                        style={{ top: -100, right: -150, zIndex: 9, maxWidth: 486 }}
                    />
                    <Overlay
                        src={fotoCarmen}
                        style={{ top: -100, right: 0, zIndex: 10, maxWidth: 440 }}
                    />
                </div>
            </div>
            <div className="home--divider" />
            <div className="wrapper has-text-white has-text-weight-light py-5 mt-5">
                <div className="columns">
                    <div className="column is-one-third">
                        <ApiState isLoading={isLoading} error={error}>
                            {body && <p>{parse(body)}</p>}
                        </ApiState>
                    </div>
                    <div className="column is-two-thirds">
                        <ul className="list-reset boxes-list boxes-list-cols-4">
                            {isReady &&
                                menuPages.map((page) => {
                                    const { primary, secondary } = splitTerm(page.term);
                                    return (
                                        <li key={page.section_id} className="full-link">
                                            <Link to={page.web_path}>
                                                <NavLabel primary={primary} secondary={secondary} />
                                            </Link>
                                        </li>
                                    );
                                })}
                        </ul>
                    </div>
                </div>
            </div>
        </Layout>
    );
}

export default Home;
